import React from 'react'
import { Link } from 'react-router-dom'
import ScrollToTop from 'react-scroll-to-top'

const Footer = () => {
  return (
    <>
    <footer className='bg-body-tertiary py-5'>
      <div className='container'>

<div className='row'>

<div className='col-lg-3 col-md-6 col-12 my-2'>
  <p className='fs-5'>Swalok Group</p>
  <p className='text-muted'>About the company About the company About the company</p>
</div>

<div className='col-lg-3 col-md-6 col-6 my-2'>
<p className='fs-5'>Important</p>
<Link className='text-muted text-decoration-none' to='/'><i className="fa-solid fa-arrow-right text-pink me-2"></i>Home</Link><br />
<Link className='text-muted text-decoration-none' to='/blogs'><i className="fa-solid fa-arrow-right text-pink me-2"></i>Blogs</Link><br />
<Link className='text-muted text-decoration-none' to='/contact'><i className="fa-solid fa-arrow-right text-pink me-2"></i>Contact</Link><br />
<Link className='text-muted text-decoration-none' to='/account'><i className="fa-solid fa-arrow-right text-pink me-2"></i>Login</Link>
</div>

<div className='col-lg-3 col-md-6 col-6 my-2'>
<p className='fs-5'>About Us</p>
<Link className='text-muted text-decoration-none' to='/about'><i className="fa-solid fa-arrow-right text-pink me-2"></i>About</Link><br />
<Link className='text-muted text-decoration-none' to='/projects'><i className="fa-solid fa-arrow-right text-pink me-2"></i>Projects</Link>
</div>

<div className='col-lg-3 col-md-6 col-12 my-2'>
<p className='fs-5'>Have Questions?</p>
<p><i class="fa-solid fa-location-dot text-pink me-3"></i>Add your location here</p>
<p><i class="fa-solid fa-phone text-pink me-3"></i>+123 456 7890</p>
<p><i class="fa-solid fa-envelope text-pink me-3"></i>info@gmail.com</p>
</div>


</div>
{/* row ends */}

<p className='text-center text-muted mt-4'>Copyright &copy; Swalok Group. All Rights Reserved. Developed by 
  <Link className='text-muted text-decoration-none' to='https://dectwinservices.com' target='_blank'> Dectwin Services Pvt Ltd</Link></p>

      </div>
    </footer>

    <ScrollToTop smooth className='scroll-to-top' viewBox="0 0 448 512"
                svgPath="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />

    </>
  )
}

export default Footer
